
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexPlDsWqHeQ7Dvav_BtM56NZu9WWVFHCLlHIvIlYeX_45SUMeta } from "/home/runner/work/dashboard/dashboard/pages/index.vue?macro=true";
import { default as indexOdyHx33KfN_9C8ryPh5r2ecjVczGjQMfy_45MeBZmP7wwMeta } from "/home/runner/work/dashboard/dashboard/pages/orders/index.vue?macro=true";
import { default as indexOUIoPmOJbgo277NRCrGkeiQhhoV_4592ucbup3a1pSwEcMeta } from "/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/index.vue?macro=true";
import { default as _91page_93EVSyQEgLjA656xFIMs1rxwa5FYswvaQHHHudLGtDGc0Meta } from "/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/[page].vue?macro=true";
import { default as indexC1G5KugGL_45hFy643NqS9EoNdpK9GiOUhcyNctVz5XcUMeta } from "/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/vouchers/[voucherId]/index.vue?macro=true";
import { default as _91page_93dajeMIX75d012GfmE1_41eB1PILNlqLvR_kWubBgxc0Meta } from "/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/vouchers/[voucherId]/[page].vue?macro=true";
import { default as ordersY5NWKZIu_45eHS2PCgn6MR_x_45qAkNdqD9KfzTeZGS0r_45QMeta } from "/home/runner/work/dashboard/dashboard/pages/orders.vue?macro=true";
import { default as indexPgA7Dk4uaOE6DS7iHCBAB9jq51ttefae3HUy_45eOe0e8Meta } from "/home/runner/work/dashboard/dashboard/pages/stores/index.vue?macro=true";
import { default as interstitialgYCHxG752vPaP_WniMtBCQLqWGktiUiMvVVm_45ekObxkMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/interstitial.vue?macro=true";
import { default as faqceiQankoahsSkcQZcA2smd6n9rQk_45We55tA5NWg_45PDUMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/faq.vue?macro=true";
import { default as indexZHSvBJbGO_45s7BQyijOJ4OQdxpnEOpeofvgPTHyCWCpYMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/index.vue?macro=true";
import { default as termsgCdprn0W4b3z_45euzYH1TptJAuW6rfYuIcfAgSjBkGRUMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/terms.vue?macro=true";
import { default as faqBtrBxJ5Cf01tQ6ZlMjUwV4fw1t6s0GLrb7KgRwHIAxYMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/faq.vue?macro=true";
import { default as designbW_8iCoqNU4vNZmGYBYKDOYQ3RWi7cOW1Sz6ZXUv9mUMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/design.vue?macro=true";
import { default as privacyvp5JMwSsKlIbgwxZUWDbaJpHUP8voyl_fKZ0QpCk_aYMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/privacy.vue?macro=true";
import { default as index3eigNZTL3vQsWIlHX9KKIzAHyxiBXiJtp86aJL2bGg8Meta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/index.vue?macro=true";
import { default as terms1LeYuvb_nGeFB5jrwOLalX4_l7wRNxmNwtTfGEVvbGUMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/terms.vue?macro=true";
import { default as design6e0WDX3LGDxaE6JIM_5b8r_CNQKaO5B4_450CAUmU9g_450Meta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/design.vue?macro=true";
import { default as privacy9iJ_xwBGr8VxN_0sXvaCUYZBBjuRJVl8zFDlLJSFgC0Meta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/privacy.vue?macro=true";
import { default as indexGdoX2A9rklOCLMbT2JkdNcHWDzI7YwV2a4MENWXp8KsMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/emails/index.vue?macro=true";
import { default as _91page_931qnjp2gWNbrM7sUkNA9j7iy4_45CCb4VvQxmHyqxsOa5oMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/emails/[page].vue?macro=true";
import { default as voucher_45codesSP1hFrgkn_5RAf6mNUWQX_45nKxtETFkJJfUiZNywwX_45oMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/voucher-codes.vue?macro=true";
import { default as indexObBnOAn7BUo8RS4eXuGfAZl84gvLPJXpQYzipsYq3isMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/emails/index.vue?macro=true";
import { default as _91page_93tnQg0AEBBR13xXCRk3VM6HD02x1VKFfsYtYoL6YWCTAMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/emails/[page].vue?macro=true";
import { default as voucher_45codeso_1HZ60zsnUDilDLUIoNePgUmvyjlbqxZODMV4evosIMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/voucher-codes.vue?macro=true";
import { default as indexOcK5ALmP8Mt8L_45RhD1Z_45ZlnGcWKBNasSTxqy02Xg0RMMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/fulfilment/index.vue?macro=true";
import { default as _91page_93G7n8DQgOrh6ln23EvXFLTXxsKcDlrFZf3crRQoTlIb0Meta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/fulfilment/[page].vue?macro=true";
import { default as index6bePc8lHAq81eaaqHu_igpU6DfPostYRRXWpazHgb1oMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/fulfilment/index.vue?macro=true";
import { default as _91page_93N2RyTAE4Uv2o7fzqxAvYKgPXApTiup5oE8R3bN2aFsQMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/fulfilment/[page].vue?macro=true";
import { default as delivery_45informationYTaxL8J61B_455QJmkyp0FLDjfJiv5udkMAQFpOGiD5ZoMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/delivery-information.vue?macro=true";
import { default as third_45party_45trackingfdI_S6LfgYv3Cbu4rUf4gjLr9jr2a935K1JsCOQJt0sMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/third-party-tracking.vue?macro=true";
import { default as delivery_45informationMY2FoLN2L2_45BJIVsWOsN_45nAEHtcTZPIIfXUOjJccKZYMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/delivery-information.vue?macro=true";
import { default as third_45party_45trackingeXr_45kXW9RaihSzKKccrJyNjhDpAlb3B7PJ11R_45ijGqAMeta } from "/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/third-party-tracking.vue?macro=true";
import { default as storesKzrJJw3tje0mmBqBl93oFcUWFwX2VhiP8NLt_8wv_45K8Meta } from "/home/runner/work/dashboard/dashboard/pages/stores.vue?macro=true";
import { default as indexO40jKkBkqeHJn1mhDqt8uQXXGqDkMvgq8m7D32VV_nAMeta } from "/home/runner/work/dashboard/dashboard/pages/reports/index.vue?macro=true";
import { default as reportsB1eHIlIZ9Q4IdxkzKbC9csbZUVeug5PIQ6FuSyrRHcoMeta } from "/home/runner/work/dashboard/dashboard/pages/reports.vue?macro=true";
import { default as index7HiBAwx2moOI5n6ONJXiUtyMlG1258UjBQP_OjSEUtEMeta } from "/home/runner/work/dashboard/dashboard/pages/products/index.vue?macro=true";
import { default as _91type_93EiUbSjtTREO4cZ7aMxG6_45_EIXQ9GpDriqMRMNEtUU7sMeta } from "/home/runner/work/dashboard/dashboard/pages/products/create/[type].vue?macro=true";
import { default as indexQ_45MbcqTV1ELLgJty8vd7fcwPSmqrHoT_45m4FWGI6WKfcMeta } from "/home/runner/work/dashboard/dashboard/pages/products/[productId]/index.vue?macro=true";
import { default as createDbTiD6HEOAdqFuIQkdXYWlw8UID6bdyNV73ROtm_uCsMeta } from "/home/runner/work/dashboard/dashboard/pages/products/create/variants/create.vue?macro=true";
import { default as create4kcFsIAh2XzGHsSgALefilhec4qeuvrV3TIdrWFytYYMeta } from "/home/runner/work/dashboard/dashboard/pages/products/[productId]/variants/create.vue?macro=true";
import { default as _91variantId_93zS_459hb1sRBuz83xO2BW7mKGB_LY54rNBWIRDGT5yjN8Meta } from "/home/runner/work/dashboard/dashboard/pages/products/[productId]/variants/[variantId].vue?macro=true";
import { default as productsjjm94nCrchG0ld2K9atSPd2TJ6VLT1Pl5TRzUTCXpXcMeta } from "/home/runner/work/dashboard/dashboard/pages/products.vue?macro=true";
import { default as indexCzf8ifdEels9z0ZpI5VIaFlHiynttQiuT4saxevglDsMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/index.vue?macro=true";
import { default as indexRnHL5ql29tlrohi8rVaxnyF6Ecm_9aaHyw8zA7qaV8oMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/index.vue?macro=true";
import { default as _91userId_93yMlS0GtCUAds4AXnBa_455PHcpLjdFXrCgaxKCEcmBC3YMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/[userId].vue?macro=true";
import { default as emaildnbQmumQUu3CGh8z_PgFInnSqx_45vvLWonvPvehftpIsMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/create/email.vue?macro=true";
import { default as usernameZGGXXu0PGFVHeMrcl3LaaUwvBXjJaUM9fntsmBEo8BAMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/create/username.vue?macro=true";
import { default as index9F_45xgAMNaUI5cfF7ug1HmDWXxruWI0y8VBPMGv_45huH0Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/invitations/index.vue?macro=true";
import { default as _91invitationId_933Rit3txzV6XUPpTSNFry_cInDF_yMa0aeuTTmMBe_RUMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users/invitations/[invitationId].vue?macro=true";
import { default as users5ZQ7TYaHp6DIsZyPpFqqNA0d1MG3UdQ4WW4zrzgUH7gMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/users.vue?macro=true";
import { default as billinghtMmwlivQRRJ8_45BVBoDWGDfuhIjmLWB4HLwJZIQM_WUMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/billing.vue?macro=true";
import { default as generalTJsgZDSMkLCXfb12YS34Ik8LGuPuoWi4BqgKAtDWHawMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/general.vue?macro=true";
import { default as indexzIPZ68yVeK84lSYrLKA10wzfdmF_45w74ojxY8JpJ_X0oMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/imports/index.vue?macro=true";
import { default as mappingeC5e93STjYjvhyVZGEBcwN8GuEZlxS96V8iI91K5NG0Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/imports/mapping.vue?macro=true";
import { default as importsbv1CbFC8qnThLHbEkneNPmG7vqF_45RrAgVGSt2NXua2kMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/imports.vue?macro=true";
import { default as indexfvShSlEnocA_45Zzy4RZCtFWYKPyJuRmENGZbB6D3sO38Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/api-tokens/index.vue?macro=true";
import { default as create3yAkC3UFmohFMVs1uc9iNSvOYClSoQn_4jnpmn1Rt38Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/api-tokens/create.vue?macro=true";
import { default as api_45tokensvNauFOL_455jlDe_45sIXL3_45qIZmr7LtcMzLf6vUtlL4xYgMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/api-tokens.vue?macro=true";
import { default as indexkZzdhkaXLCdMJS3tATVbjWgJIX0oUgLw7GEECJFZvA4Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/index.vue?macro=true";
import { default as createQ2D22wrPJfc5I280oi_45h46JIJYHc13LhIzJaH_9bN_sMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/create.vue?macro=true";
import { default as _91costCentreId_93dFHEO_XY65HejcUcz9Z_399hvzNSfEXJbcBXvdrHqkQMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/[costCentreId].vue?macro=true";
import { default as cost_45centresvoLrNZ7os8d8kaKUHC0ai5BjxSaYQQHa5S926F8Iv8gMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/cost-centres.vue?macro=true";
import { default as indexvuMNCevtLHG4Dg2fwtxpWGIqqPgtWKt1H24jcZxyCLYMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/email-domains/index.vue?macro=true";
import { default as _91hostname_93CHMk2mibDzETx8g31654qmJBNkS8_hFJMgHqBXebJYQMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/email-domains/[hostname].vue?macro=true";
import { default as email_45domainsyQuvXw_1rDdC5d024uu3cpoxrdGestD5ohCsQ6GT9ocMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/email-domains.vue?macro=true";
import { default as indexn8XkQbIO8IhLa2iIKI39TC9aTgLWcSbCA5Z8ahnqgaUMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/index.vue?macro=true";
import { default as _91uuid_935ucLZlDjAkJVI5IvCzgr5xSwuX8GWmWTBAa9Lw_45LaTsMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/[uuid].vue?macro=true";
import { default as createpKnsJTu3MAL6kw99KuSn7OqCc6AKD1mZWeUp1xEggIsMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/create.vue?macro=true";
import { default as store_45switchersT1TPnIFOsG_h7OKX5oU6nJo7KTPrHO3O4QlDfSXsh7QMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/store-switchers.vue?macro=true";
import { default as indexZiERxfJPcIx0d74ExdMDDnZJcl2dtlgUUwWgoN6WXkEMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/index.vue?macro=true";
import { default as createawlW_454PyHpgjaWNPWeyXx1gTRwdj1JMvcaXqwbz4XlIMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/create.vue?macro=true";
import { default as _91redeemLocationId_93IlAfmisNq6iiHu0ROTBR5BPfDMvdLW1ct1dnhAnGP2AMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/[redeemLocationId].vue?macro=true";
import { default as redeem_45locationsSQNMnGC_45yH98NiX52aBwD8EYeZwrAY46nGz31GttWQEMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations.vue?macro=true";
import { default as indexiz7Lnt3K2_Jw0srXRRnCrhY_45Jf5WV33sU01lxMAa_PcMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/bulk-vouchers/index.vue?macro=true";
import { default as mappingr9NAHhLF4w8a6GOSHgMatqAOzkSCE0q_pFlfwb_45zUIQMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/bulk-vouchers/mapping.vue?macro=true";
import { default as indexF0_45hexG7uezUTJP7uzUgjss252W15tMWZQ_jtDkQe6AMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/index.vue?macro=true";
import { default as indexr_45PE_YrcH0LvP4nkVN8sBhGQO2OixDqCmunSpDYo3lgMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools/index.vue?macro=true";
import { default as segmentYH1nLivOZtnSQy5weEHF98EM_45mUq0vkqu9zkMO64cYsMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools/segment.vue?macro=true";
import { default as voucher_45reference_45poolstDkDiMmwZn7Gsz_2A1N1K6rLKtt6wNhYOuLAD76iLr4Meta } from "/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools.vue?macro=true";
import { default as _91gatewayId_9346o6MgcmvFN8Gi2HnF_NCs7OsBIwoWvk1h79RVwXuaYMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/[gatewayId].vue?macro=true";
import { default as paypalPMzDBD0bi2I6_4a0RNDNSnRCVj27QWxB4yf6IXEb9CAMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/paypal.vue?macro=true";
import { default as stripeJbaaOdSWcPUq4XVusgfKwgdDcafmpJPjNdPpqq99zmMMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/stripe.vue?macro=true";
import { default as fanbasisPrMmMljcCgU5Wd4uk18_5cdbs1XYsHloFJZY5VBSIAoMeta } from "/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/fanbasis.vue?macro=true";
import { default as settingsxnGVjAse_45_45ayKTgQ1uHD5V5lj68s9rxqyJ7vO4S_dYoMeta } from "/home/runner/work/dashboard/dashboard/pages/settings.vue?macro=true";
import { default as index17Pfceug7GtLysxPu_453IXQujDKVQw_45z4lt3OwgSES2EMeta } from "/home/runner/work/dashboard/dashboard/pages/categories/index.vue?macro=true";
import { default as _91categoryId_93rMAbY38Zb4tQ_L6X8HO9O90Er9aJTAjWLWrrgdKGZ2kMeta } from "/home/runner/work/dashboard/dashboard/pages/categories/[categoryId].vue?macro=true";
import { default as _91salesChannelId_93ZS_45ZlBle5QgDpeDDQW2lQ_o9isO53zxyM6Fjp8WKCawMeta } from "/home/runner/work/dashboard/dashboard/pages/categories/create/[salesChannelId].vue?macro=true";
import { default as categoriespbsRrbGBAShiv4DiRiGPrK87TJ1zYrXrEsXbyKkC4cIMeta } from "/home/runner/work/dashboard/dashboard/pages/categories.vue?macro=true";
import { default as indexB2hd49OJ_HY8slE34DG74THKHJIYsN1u8rw1stDTTfgMeta } from "/home/runner/work/dashboard/dashboard/pages/fulfilment/index.vue?macro=true";
import { default as fulfilledpv9TiWo0IBluGAe5TXZQK9RIKiL8qCVZKxmWnbEn6hkMeta } from "/home/runner/work/dashboard/dashboard/pages/fulfilment/fulfilled.vue?macro=true";
import { default as fulfilmentlyp39NEq1rtdCtdzn3hF2_45h2e0tIw_45x_YzSbkECEtLkMeta } from "/home/runner/work/dashboard/dashboard/pages/fulfilment.vue?macro=true";
import { default as logout0IlBBiMA0IhtVEoqcevzuKj0wPt2A7jsZeEAsC2m2KcMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/logout.vue?macro=true";
import { default as indexRnfLxo79WUfXzYzf5cPC_aiO_WY0MDH2i2v0O49wPbwMeta } from "/home/runner/work/dashboard/dashboard/pages/enhancements/index.vue?macro=true";
import { default as createT88wohd_45cZa0CP9KLUCLAYx8bv_o6_Gt1YZVcSdqOD4Meta } from "/home/runner/work/dashboard/dashboard/pages/enhancements/create.vue?macro=true";
import { default as _91enhancementId_93P0SBmpue88BWXnm1NunmvU8P1TpWsOJi45kzZm7EdisMeta } from "/home/runner/work/dashboard/dashboard/pages/enhancements/[enhancementId].vue?macro=true";
import { default as enhancements61WCkJUEb4Aw6ufMJyTOELF6F96rk0s67ESNuBe4lYYMeta } from "/home/runner/work/dashboard/dashboard/pages/enhancements.vue?macro=true";
import { default as settingsU_45D1pHi0VLsWBMG7y7qAS6xzqeYLWnVgTabY5v_45OjZoMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/settings.vue?macro=true";
import { default as index96HisHMHBcayttwVYVkRPoRvDSDrISWG4TJybTtwIHYMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/index.vue?macro=true";
import { default as indexCqtZBCHi_UJzuTH2LfZueyHDtzDZ01jVG9lP8wQyn3AMeta } from "/home/runner/work/dashboard/dashboard/pages/analytics/index.vue?macro=true";
import { default as indexU0wvXSyqG063NWEVoDmZ9jMzFsWOt30JbxELKGebaacMeta } from "/home/runner/work/dashboard/dashboard/pages/discounts/index.vue?macro=true";
import { default as indexan5ssq4h77udC5mbo6fLh424DkgZPxtXooCpqibgUtsMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/login/index.vue?macro=true";
import { default as account_45suspendedbCybyIULjWjbR5rk84VeX1qNZKB6gti_oBOoy1KohWUMeta } from "/home/runner/work/dashboard/dashboard/pages/account-suspended.vue?macro=true";
import { default as invalidLa6SxtAPcZN7doFRDoRaFA0v3Yb0mN2ykdm14DW1TgoMeta } from "/home/runner/work/dashboard/dashboard/pages/invitation/invalid.vue?macro=true";
import { default as reset_45password2sUv6xilDeUOBzUDvld3EjIm6fsimnj1rilFaCmhWsUMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/reset-password.vue?macro=true";
import { default as indexbUXToDWDwja0wMSUo6qrVfHflo_upxTsPyMW_bZA1Q8Meta } from "/home/runner/work/dashboard/dashboard/pages/terminal/redeem/index.vue?macro=true";
import { default as settingsmpxkh_hPoWPhehXbjM7GvRE4RfO_KGLZAT5q9JzCMzUMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/auth/settings.vue?macro=true";
import { default as _91type_93NhLuM8Wo_3l8sG2ZFbY3TdCiaoTPYxiDpZZwdZOGeEUMeta } from "/home/runner/work/dashboard/dashboard/pages/discounts/create/[type].vue?macro=true";
import { default as account_45pending_45deletionOUxsnzX1AeekorWp8hB4GU93Bh_45_psBMoci3ZgRRPOUMeta } from "/home/runner/work/dashboard/dashboard/pages/account-pending-deletion.vue?macro=true";
import { default as _91accountSlug_93oQxQuTV06pHjWulv0T6jcRntnX9JV9lU2mQeF2ePMXkMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/login/[accountSlug].vue?macro=true";
import { default as _91invitationId_9399owlZqbWwjTfBoJMUCZew95l8O09wIxnKanp3zP_45jwMeta } from "/home/runner/work/dashboard/dashboard/pages/invitation/[invitationId].vue?macro=true";
import { default as indexkoJOLAt7v_45U6_ztIcVlxhoBm1L02LxT_45AB4g55RN63sMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/index.vue?macro=true";
import { default as request_45password_45resetyfCX8RcBCXpY64_45o3RNtF9zCdaw54iylFZD2fs_45NQHQMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/request-password-reset.vue?macro=true";
import { default as _91reference_93bL7JV0SP_45OuUGPosSe_45n9vddUqwKLoYlEGqAhgpedDAMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/redeem/[reference].vue?macro=true";
import { default as codes2VrWNnxSk9AZn9z9sQ1XV6TSyL_L21iK_45bIAIfwEIw0Meta } from "/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/codes.vue?macro=true";
import { default as indexlOVhk1fC2dSjtKZTIdZ3ktW9EaKD5LERi9dQ_45WzyN_450Meta } from "/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/index.vue?macro=true";
import { default as confirmationHWs1EXsBC1fhXsGmc6HtekKcVzU6J_45jCiSEVvnclQnAMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/redeem/confirmation.vue?macro=true";
import { default as reset_45password_45confirmationEST_8dPna9KZ1IZ8t7ABC63J4aBBTmqhcTBNiWxX79gMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/reset-password-confirmation.vue?macro=true";
import { default as invalid_45password_45reset_45tokenHVCOEB8dvFPc3PH4fL_kcIDEz6TTZ6J27aoKLgEOfAEMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/invalid-password-reset-token.vue?macro=true";
import { default as _91hash_93IzBm0b4LRjeCKRUX_FvqzGVlXzMLfrIKuHufdFzJt2EMeta } from "/home/runner/work/dashboard/dashboard/pages/auth/verify-email/[userId]/[hash].vue?macro=true";
import { default as createzyNv0dTROXCVtpo2J1l3XQFeLwlLHnGZw9aOAP2Wh4sMeta } from "/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/group/create.vue?macro=true";
import { default as request_45password_45reset_45confirmation5dPmKsmO3mF9ZQIS5pIQCQLUMqnvunET2OKpJCViR24Meta } from "/home/runner/work/dashboard/dashboard/pages/auth/request-password-reset-confirmation.vue?macro=true";
import { default as _91groupIndex_93UsMTCCqLjlpmdmZyP94HQty2Nt2gUI1jl0aVKvgQ8UsMeta } from "/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/group/[groupIndex].vue?macro=true";
import { default as create503nF3g_45w5NZixEcu6IT_NwfoYNhYr5mnIc0MTMDX9IMeta } from "/home/runner/work/dashboard/dashboard/pages/discounts/create/per-product/group/create.vue?macro=true";
import { default as indexDLC2zTDdWUmphCmh_45yNp3bd3tvoddh33v1qZFR7SpkQMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/redeem/voucher/[reference]/index.vue?macro=true";
import { default as indexCjC6dkob8jDj_w0Hc2Bg_45A_Dg3UZWHWNdLw0zDDFfqIMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/index.vue?macro=true";
import { default as summaryMyg9rVCbSMtbZaba2o3H_Sfh04YGnIzpHIWWC9wGch0Meta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/summary.vue?macro=true";
import { default as waitingDSyaLjD6kGVKAgda6VE7_457K0xSFFHyg8Lq1V9yoTRS4Meta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/waiting.vue?macro=true";
import { default as completenu6G3EUpcpiqY1Yt1MdGKKkzM_45kiDPHTJp5Lh49mivQMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/complete.vue?macro=true";
import { default as _91redeemableId_93X7RubbEgCbLpa36yyiQJVotHPBZarg7eQalLhnAqVMYMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/redeem/voucher/[reference]/[redeemableId].vue?macro=true";
import { default as postzk1Wl4U67rPrIK3_SDfP03CGKvHO0ttz8uO58U_6twYMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/post.vue?macro=true";
import { default as emailLtuMMNLxCw8ZVOBksrC1gqdSBwdC75oYXW5EIz_45dmPEMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/email.vue?macro=true";
import { default as indexjJlDFfF_45SXh_45n8NUFTMCJ6EVF641T0zH7HuFxE09cpUMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/index.vue?macro=true";
import { default as collectLZRYavwgByy8KvOH7JlNQlX5rq7lIvjK38T9tt4NCAMMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/collect.vue?macro=true";
import { default as indextkfFz2PpgW5xJoKPERIZKADUTMRPeSkx6f6bY0zucm0Meta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/index.vue?macro=true";
import { default as variantAt8ydsQnrVTR920XbGtlD_45Oc0_451naIB255Yh8j8A_oQMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/variant.vue?macro=true";
import { default as monetaryrsuwHvTW4TKbF_jvtJjlmmM0hw0eig1yUfJAqcHIx1UMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/monetary.vue?macro=true";
import { default as enhancementslE41HcQU7c1qo_45HMcsFhXeFHjiHajysMIEoQq_sSpOcMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/enhancements.vue?macro=true";
import { default as product_45infor0pas7Oo0g8Vkn3_45GbS4EVCCT21y_45dWBluy2LOIy_OkMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/product-info.vue?macro=true";
import { default as personalisationIWbPD7i1VpH7ZT6DtTlCUP7_45tU3PGvrqWUIquZAruzUMeta } from "/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/personalisation.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/index.vue")
  },
  {
    name: ordersY5NWKZIu_45eHS2PCgn6MR_x_45qAkNdqD9KfzTeZGS0r_45QMeta?.name,
    path: "/orders",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders.vue"),
    children: [
  {
    name: "orders",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders/index.vue")
  },
  {
    name: "orders-orderId",
    path: ":orderId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/index.vue")
  },
  {
    name: "orders-orderId-page",
    path: ":orderId()/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/[page].vue")
  },
  {
    name: "orders-orderId-vouchers-voucherId",
    path: ":orderId()/vouchers/:voucherId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/vouchers/[voucherId]/index.vue")
  },
  {
    name: "orders-orderId-vouchers-voucherId-page",
    path: ":orderId()/vouchers/:voucherId()/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/orders/[orderId]/vouchers/[voucherId]/[page].vue")
  }
]
  },
  {
    name: storesKzrJJw3tje0mmBqBl93oFcUWFwX2VhiP8NLt_8wv_45K8Meta?.name,
    path: "/stores",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores.vue"),
    children: [
  {
    name: "stores",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/index.vue")
  },
  {
    name: "stores-interstitial",
    path: "interstitial",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/interstitial.vue")
  },
  {
    name: "stores-create-type-faq",
    path: "create/:type()/faq",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/faq.vue")
  },
  {
    name: "stores-create-type",
    path: "create/:type()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/index.vue")
  },
  {
    name: "stores-create-type-terms",
    path: "create/:type()/terms",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/terms.vue")
  },
  {
    name: "stores-salesChannelId-faq",
    path: ":salesChannelId()/faq",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/faq.vue")
  },
  {
    name: "stores-create-type-design",
    path: "create/:type()/design",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/design.vue")
  },
  {
    name: "stores-create-type-privacy",
    path: "create/:type()/privacy",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/privacy.vue")
  },
  {
    name: "stores-salesChannelId",
    path: ":salesChannelId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/index.vue")
  },
  {
    name: "stores-salesChannelId-terms",
    path: ":salesChannelId()/terms",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/terms.vue")
  },
  {
    name: "stores-salesChannelId-design",
    path: ":salesChannelId()/design",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/design.vue")
  },
  {
    name: "stores-salesChannelId-privacy",
    path: ":salesChannelId()/privacy",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/privacy.vue")
  },
  {
    name: "stores-create-type-emails",
    path: "create/:type()/emails",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/emails/index.vue")
  },
  {
    name: "stores-create-type-emails-page",
    path: "create/:type()/emails/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/emails/[page].vue")
  },
  {
    name: "stores-create-type-voucher-codes",
    path: "create/:type()/voucher-codes",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/voucher-codes.vue")
  },
  {
    name: "stores-salesChannelId-emails",
    path: ":salesChannelId()/emails",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/emails/index.vue")
  },
  {
    name: "stores-salesChannelId-emails-page",
    path: ":salesChannelId()/emails/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/emails/[page].vue")
  },
  {
    name: "stores-salesChannelId-voucher-codes",
    path: ":salesChannelId()/voucher-codes",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/voucher-codes.vue")
  },
  {
    name: "stores-create-type-fulfilment",
    path: "create/:type()/fulfilment",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/fulfilment/index.vue")
  },
  {
    name: "stores-create-type-fulfilment-page",
    path: "create/:type()/fulfilment/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/fulfilment/[page].vue")
  },
  {
    name: "stores-salesChannelId-fulfilment",
    path: ":salesChannelId()/fulfilment",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/fulfilment/index.vue")
  },
  {
    name: "stores-salesChannelId-fulfilment-page",
    path: ":salesChannelId()/fulfilment/:page()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/fulfilment/[page].vue")
  },
  {
    name: "stores-create-type-delivery-information",
    path: "create/:type()/delivery-information",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/delivery-information.vue")
  },
  {
    name: "stores-create-type-third-party-tracking",
    path: "create/:type()/third-party-tracking",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/create/[type]/third-party-tracking.vue")
  },
  {
    name: "stores-salesChannelId-delivery-information",
    path: ":salesChannelId()/delivery-information",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/delivery-information.vue")
  },
  {
    name: "stores-salesChannelId-third-party-tracking",
    path: ":salesChannelId()/third-party-tracking",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/stores/[salesChannelId]/third-party-tracking.vue")
  }
]
  },
  {
    name: reportsB1eHIlIZ9Q4IdxkzKbC9csbZUVeug5PIQ6FuSyrRHcoMeta?.name,
    path: "/reports",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/reports.vue"),
    children: [
  {
    name: "reports",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/reports/index.vue")
  }
]
  },
  {
    name: productsjjm94nCrchG0ld2K9atSPd2TJ6VLT1Pl5TRzUTCXpXcMeta?.name,
    path: "/products",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products.vue"),
    children: [
  {
    name: "products",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/index.vue")
  },
  {
    name: "products-create-type",
    path: "create/:type()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/create/[type].vue")
  },
  {
    name: "products-productId",
    path: ":productId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/[productId]/index.vue")
  },
  {
    name: "products-create-variants-create",
    path: "create/variants/create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/create/variants/create.vue")
  },
  {
    name: "products-productId-variants-create",
    path: ":productId()/variants/create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/[productId]/variants/create.vue")
  },
  {
    name: "products-productId-variants-variantId",
    path: ":productId()/variants/:variantId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/products/[productId]/variants/[variantId].vue")
  }
]
  },
  {
    name: settingsxnGVjAse_45_45ayKTgQ1uHD5V5lj68s9rxqyJ7vO4S_dYoMeta?.name,
    path: "/settings",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings.vue"),
    children: [
  {
    name: "settings",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/index.vue")
  },
  {
    name: users5ZQ7TYaHp6DIsZyPpFqqNA0d1MG3UdQ4WW4zrzgUH7gMeta?.name,
    path: "users",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users.vue"),
    children: [
  {
    name: "settings-users",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/index.vue")
  },
  {
    name: "settings-users-userId",
    path: ":userId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/[userId].vue")
  },
  {
    name: "settings-users-create-email",
    path: "create/email",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/create/email.vue")
  },
  {
    name: "settings-users-create-username",
    path: "create/username",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/create/username.vue")
  },
  {
    name: "settings-users-invitations",
    path: "invitations",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/invitations/index.vue")
  },
  {
    name: "settings-users-invitations-invitationId",
    path: "invitations/:invitationId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/users/invitations/[invitationId].vue")
  }
]
  },
  {
    name: "settings-billing",
    path: "billing",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/billing.vue")
  },
  {
    name: "settings-general",
    path: "general",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/general.vue")
  },
  {
    name: importsbv1CbFC8qnThLHbEkneNPmG7vqF_45RrAgVGSt2NXua2kMeta?.name,
    path: "imports",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/imports.vue"),
    children: [
  {
    name: "settings-imports",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/imports/index.vue")
  },
  {
    name: "settings-imports-mapping",
    path: "mapping",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/imports/mapping.vue")
  }
]
  },
  {
    name: api_45tokensvNauFOL_455jlDe_45sIXL3_45qIZmr7LtcMzLf6vUtlL4xYgMeta?.name,
    path: "api-tokens",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/api-tokens.vue"),
    children: [
  {
    name: "settings-api-tokens",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/api-tokens/index.vue")
  },
  {
    name: "settings-api-tokens-create",
    path: "create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/api-tokens/create.vue")
  }
]
  },
  {
    name: cost_45centresvoLrNZ7os8d8kaKUHC0ai5BjxSaYQQHa5S926F8Iv8gMeta?.name,
    path: "cost-centres",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/cost-centres.vue"),
    children: [
  {
    name: "settings-cost-centres",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/index.vue")
  },
  {
    name: "settings-cost-centres-create",
    path: "create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/create.vue")
  },
  {
    name: "settings-cost-centres-costCentreId",
    path: ":costCentreId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/cost-centres/[costCentreId].vue")
  }
]
  },
  {
    name: email_45domainsyQuvXw_1rDdC5d024uu3cpoxrdGestD5ohCsQ6GT9ocMeta?.name,
    path: "email-domains",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/email-domains.vue"),
    children: [
  {
    name: "settings-email-domains",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/email-domains/index.vue")
  },
  {
    name: "settings-email-domains-hostname",
    path: ":hostname()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/email-domains/[hostname].vue")
  }
]
  },
  {
    name: store_45switchersT1TPnIFOsG_h7OKX5oU6nJo7KTPrHO3O4QlDfSXsh7QMeta?.name,
    path: "store-switchers",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/store-switchers.vue"),
    children: [
  {
    name: "settings-store-switchers",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/index.vue")
  },
  {
    name: "settings-store-switchers-uuid",
    path: ":uuid()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/[uuid].vue")
  },
  {
    name: "settings-store-switchers-create",
    path: "create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/store-switchers/create.vue")
  }
]
  },
  {
    name: redeem_45locationsSQNMnGC_45yH98NiX52aBwD8EYeZwrAY46nGz31GttWQEMeta?.name,
    path: "redeem-locations",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations.vue"),
    children: [
  {
    name: "settings-redeem-locations",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/index.vue")
  },
  {
    name: "settings-redeem-locations-create",
    path: "create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/create.vue")
  },
  {
    name: "settings-redeem-locations-redeemLocationId",
    path: ":redeemLocationId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/redeem-locations/[redeemLocationId].vue")
  }
]
  },
  {
    name: "settings-bulk-vouchers",
    path: "bulk-vouchers",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/bulk-vouchers/index.vue")
  },
  {
    name: "settings-bulk-vouchers-mapping",
    path: "bulk-vouchers/mapping",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/bulk-vouchers/mapping.vue")
  },
  {
    name: "settings-payment-gateways",
    path: "payment-gateways",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/index.vue")
  },
  {
    name: voucher_45reference_45poolstDkDiMmwZn7Gsz_2A1N1K6rLKtt6wNhYOuLAD76iLr4Meta?.name,
    path: "voucher-reference-pools",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools.vue"),
    children: [
  {
    name: "settings-voucher-reference-pools",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools/index.vue")
  },
  {
    name: "settings-voucher-reference-pools-segment",
    path: "segment",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/voucher-reference-pools/segment.vue")
  }
]
  },
  {
    name: "settings-payment-gateways-gatewayId",
    path: "payment-gateways/:gatewayId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/[gatewayId].vue")
  },
  {
    name: "settings-payment-gateways-connect-paypal",
    path: "payment-gateways/connect/paypal",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/paypal.vue")
  },
  {
    name: "settings-payment-gateways-connect-stripe",
    path: "payment-gateways/connect/stripe",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/stripe.vue")
  },
  {
    name: "settings-payment-gateways-connect-fanbasis",
    path: "payment-gateways/connect/fanbasis",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/settings/payment-gateways/connect/fanbasis.vue")
  }
]
  },
  {
    name: categoriespbsRrbGBAShiv4DiRiGPrK87TJ1zYrXrEsXbyKkC4cIMeta?.name,
    path: "/categories",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/categories.vue"),
    children: [
  {
    name: "categories",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/categories/index.vue")
  },
  {
    name: "categories-categoryId",
    path: ":categoryId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/categories/[categoryId].vue")
  },
  {
    name: "categories-create-salesChannelId",
    path: "create/:salesChannelId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/categories/create/[salesChannelId].vue")
  }
]
  },
  {
    name: fulfilmentlyp39NEq1rtdCtdzn3hF2_45h2e0tIw_45x_YzSbkECEtLkMeta?.name,
    path: "/fulfilment",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/fulfilment.vue"),
    children: [
  {
    name: "fulfilment",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/fulfilment/index.vue")
  },
  {
    name: "fulfilment-fulfilled",
    path: "fulfilled",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/fulfilment/fulfilled.vue")
  }
]
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/logout.vue")
  },
  {
    name: enhancements61WCkJUEb4Aw6ufMJyTOELF6F96rk0s67ESNuBe4lYYMeta?.name,
    path: "/enhancements",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/enhancements.vue"),
    children: [
  {
    name: "enhancements",
    path: "",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/enhancements/index.vue")
  },
  {
    name: "enhancements-create",
    path: "create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/enhancements/create.vue")
  },
  {
    name: "enhancements-enhancementId",
    path: ":enhancementId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/enhancements/[enhancementId].vue")
  }
]
  },
  {
    name: "auth-settings",
    path: "/auth/settings",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/settings.vue")
  },
  {
    name: "terminal",
    path: "/terminal",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/index.vue")
  },
  {
    name: "analytics",
    path: "/analytics",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/analytics/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/login/index.vue")
  },
  {
    name: "account-suspended",
    path: "/account-suspended",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/account-suspended.vue")
  },
  {
    name: "invitation-invalid",
    path: "/invitation/invalid",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/invitation/invalid.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/reset-password.vue")
  },
  {
    name: "terminal-redeem",
    path: "/terminal/redeem",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/redeem/index.vue")
  },
  {
    name: "terminal-auth-settings",
    path: "/terminal/auth/settings",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/auth/settings.vue")
  },
  {
    name: "discounts-create-type",
    path: "/discounts/create/:type()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/create/[type].vue")
  },
  {
    name: "account-pending-deletion",
    path: "/account-pending-deletion",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/account-pending-deletion.vue")
  },
  {
    name: "auth-login-accountSlug",
    path: "/auth/login/:accountSlug()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/login/[accountSlug].vue")
  },
  {
    name: "invitation-invitationId",
    path: "/invitation/:invitationId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/invitation/[invitationId].vue")
  },
  {
    name: "terminal-sell-type",
    path: "/terminal/sell/:type()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/index.vue")
  },
  {
    name: "auth-request-password-reset",
    path: "/auth/request-password-reset",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/request-password-reset.vue")
  },
  {
    name: "terminal-redeem-reference",
    path: "/terminal/redeem/:reference()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/redeem/[reference].vue")
  },
  {
    name: "discounts-discountId-codes",
    path: "/discounts/:discountId()/codes",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/codes.vue")
  },
  {
    name: "discounts-discountId",
    path: "/discounts/:discountId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/index.vue")
  },
  {
    name: "terminal-redeem-confirmation",
    path: "/terminal/redeem/confirmation",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/redeem/confirmation.vue")
  },
  {
    name: "auth-reset-password-confirmation",
    path: "/auth/reset-password-confirmation",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/reset-password-confirmation.vue")
  },
  {
    name: "auth-invalid-password-reset-token",
    path: "/auth/invalid-password-reset-token",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/invalid-password-reset-token.vue")
  },
  {
    name: "auth-verify-email-userId-hash",
    path: "/auth/verify-email/:userId()/:hash()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/verify-email/[userId]/[hash].vue")
  },
  {
    name: "discounts-discountId-group-create",
    path: "/discounts/:discountId()/group/create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/group/create.vue")
  },
  {
    name: "auth-request-password-reset-confirmation",
    path: "/auth/request-password-reset-confirmation",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/auth/request-password-reset-confirmation.vue")
  },
  {
    name: "discounts-discountId-group-groupIndex",
    path: "/discounts/:discountId()/group/:groupIndex()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/[discountId]/group/[groupIndex].vue")
  },
  {
    name: "discounts-create-per-product-group-create",
    path: "/discounts/create/per-product/group/create",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/discounts/create/per-product/group/create.vue")
  },
  {
    name: "terminal-redeem-voucher-reference",
    path: "/terminal/redeem/voucher/:reference()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/redeem/voucher/[reference]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId",
    path: "/terminal/sell/:type()/:salesChannelId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-summary",
    path: "/terminal/sell/:type()/:salesChannelId()/summary",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/summary.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-waiting",
    path: "/terminal/sell/:type()/:salesChannelId()/waiting",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/waiting.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-complete",
    path: "/terminal/sell/:type()/:salesChannelId()/complete",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/complete.vue")
  },
  {
    name: "terminal-redeem-voucher-reference-redeemableId",
    path: "/terminal/redeem/voucher/:reference()/:redeemableId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/redeem/voucher/[reference]/[redeemableId].vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-post",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/post",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/post.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-email",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/email",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/email.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-delivery-collect",
    path: "/terminal/sell/:type()/:salesChannelId()/delivery/collect",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/delivery/collect.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/index.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-variant",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/variant",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/variant.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-monetary",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/monetary",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/monetary.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-enhancements",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/enhancements",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/enhancements.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-product-info",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/product-info",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/product-info.vue")
  },
  {
    name: "terminal-sell-type-salesChannelId-p-productId-personalisation",
    path: "/terminal/sell/:type()/:salesChannelId()/p/:productId()/personalisation",
    component: () => import("/home/runner/work/dashboard/dashboard/pages/terminal/sell/[type]/[salesChannelId]/p/[productId]/personalisation.vue")
  }
]